import { Modal, Image } from 'antd';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { useRef, useState, useEffect } from 'react';
import Media1 from '../../assets/imgage/wordBook/howToPlay1.png';
import Media2 from '../../assets/imgage/wordBook/howToPlay2.png';
import Media3 from '../../assets/imgage/wordBook/howToPlay3.png';
import Media4 from '../../assets/imgage/wordBook/howToPlay4.png';

const ModalHowToPlay = ({ isOpen = false, onClose }) => {
  const swiperRef = useRef(null);
  const [startSwipe, setStartSwipe] = useState(true);
  const [endSwipe, setEndSwipe] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const swiper = swiperRef.current?.swiper;
      if (swiper) {
        swiper.slideTo(0);
      }
      setStartSwipe(true);
      setEndSwipe(false);
    } else {
    }
  }, [isOpen]);

  const goToSlideNext = () => {
    const swiper = swiperRef.current?.swiper;
    if (swiper) {
      swiper.slideTo(swiper.activeIndex + 1);
    }
  };

  const goToSlidePrevios = () => {
    const swiper = swiperRef.current?.swiper;
    if (swiper) {
      swiper.slideTo(swiper.activeIndex - 1);
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={375}
      className="custom-howtoplay-modal"
    >
      <div className="bHeader">
        <p>วิธีเล่นเกม Wordbook Quiz</p>
        <p> กับมาร์ชคุง</p>
        <a className="btnCloseModal" onClick={onClose}></a>
      </div>

      <div className="bInner">
        <div className="bDetails">
          <Swiper
            ref={swiperRef}
            spaceBetween={13}
            pagination={{ clickable: true }}
            modules={[Pagination]}
            onSlideChange={(swiper) => {
              setStartSwipe(swiper.activeIndex === 0);
              setEndSwipe(swiper.activeIndex === 3);
            }}
          >
            <SwiperSlide>
              <Image preview={false} src={Media1}></Image>
              <div className="sDetails">
                <div className="sDetailsInner">
                  <h1>1. เลือกการ์ดคำถามที่อยากเล่น</h1>
                  <p>เลือกการ์ดที่สนใจ แล้วคลิกเข้าไปเลย~ </p>
                  <p>มาร์ชคุงรออยู่ในนั้นพร้อมคำถามสนุก ๆ เพียบ!</p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <Image preview={false} src={Media2}></Image>
              <div className="sDetails">
                <div className="sDetailsInner">
                  <h1>2. เริ่มตอบคำถามได้เลย!</h1>
                  <p>• พอเข้ามาแล้ว จะเห็นคำถามจากมาร์ชคุง</p>
                  <p>• คลิกที่บิสกิตเพื่อเลือกคำที่ถูกต้อง</p>
                  <p>&nbsp;&nbsp;แล้วกดเติมคำตอบ</p>
                  <p>• กดส่งคำตอบเพื่อยืนยันอีกครั้งได้เลย~ </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <Image preview={false} src={Media3}></Image>
              <div className="sDetails">
                <div className="sDetailsInner">
                  <h1>3. รับหัวใจ และสะสมให้ครบ 10 ดวง </h1>
                  <h1>&nbsp;&nbsp;&nbsp;เพื่อแลกของรางวัล</h1>
                  <p>• เมื่อตอบคำถามสำเร็จ จะได้รับหัวใจไปเลย </p>
                  <p>&nbsp;&nbsp;1 ดวงต่อการตอบ 1 คำถาม</p>
                  <p>• เมื่อครบ 10 ดวงแล้ว ไปยัง Wordbook </p>
                  <p>&nbsp;&nbsp;Prize เพื่อแลกของรางวัลกันเลย! </p>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <Image preview={false} src={Media4}></Image>
              <div className="sDetails">
                <div className="sDetailsInner">
                  <h1>4. สามารถตอบคำถามได้เรื่อยๆ ทั้งหมด</h1>
                  <h1>&nbsp;&nbsp;&nbsp;32 ข้อได้เลย</h1>
                  <p>• เมื่อสะสมหัวใจครบ 10 ดวงแล้ว</p>
                  <p>&nbsp;&nbsp;ยังสามารถเข้ามาตอบคำถามได้ไม่จำกัด </p>
                  <p>&nbsp;&nbsp;และแต่ละข้อจะได้รับ 1 Point</p>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

        <div className="bBtn">
          <button
            disabled={startSwipe}
            className="btn outline btnModalHowToplay"
            onClick={goToSlidePrevios}
          >
            ย้อนกลับ
          </button>

          {endSwipe ? (
            <button
              className="btn btnUnderstand btnModalHowToplay"
              onClick={onClose}
            >
              เข้าใจแล้ว
            </button>
          ) : (
            <button
              className="btn outline btnModalHowToplay"
              onClick={goToSlideNext}
            >
              ต่อไป
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ModalHowToPlay;
